import { UserManager, WebStorageStateStore, } from "oidc-client-ts";

export const userManager = new UserManager({
  // authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY || 'https://www.jewelrydesign.ai/iam/realms/sbv-realm',
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY || 'https://tryon.stylebyvida.com/iam/realms/sbv-jewel',
  // client_id: process.env.REACT_APP_KEYCLOAK_CLIENT || 'sbv-j2-unity-render-client',
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT || 'sbv-jewel-client',
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  silent_redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  monitorSession: true, // this allows cross tab login/logout detection
});


export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};